import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css'; // Cargamos Bootstrap primero
import './index.css'; // Después nuestros estilos que sobreescriben
import 'react-bootstrap-typeahead/css/Typeahead.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
